export default __webpack_public_path__ + "static/media/PosterMB-2.b32e13c8.JPG";